import { combineReducers } from "redux";
import LoginReducer from "../pages/Login/reducer";
import documentReducer from "../pages/Documents/reducer";
import agreementsReducer from "../pages/Agreements/reducer";
import profileReducer from "../pages/Profile/reducer";
import jobOpenigsReducer from "../pages/JobOpenings/reducer";

const appReducer = combineReducers({
  login: LoginReducer,
  document: documentReducer,
  agreement: agreementsReducer,
  profile: profileReducer,
  jobOpening: jobOpenigsReducer,
});

export default appReducer;
